import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=9d77ca4e&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d77ca4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d77ca4e')) {
      api.createRecord('9d77ca4e', component.options)
    } else {
      api.reload('9d77ca4e', component.options)
    }
    module.hot.accept("./MessageList.vue?vue&type=template&id=9d77ca4e&scoped=true", function () {
      api.rerender('9d77ca4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/MessageList.vue"
export default component.exports